"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomain = void 0;
const getDomain = () => {
    const currentDomain = document.domain.split('.');
    currentDomain.shift();
    let domain = currentDomain.join('.');
    if (!domain) {
        return 'localhost';
    }
    domain = `.${domain}`;
    return domain;
};
exports.getDomain = getDomain;
